import { GroundWater } from "../../../models";
import { DataProviderArgs } from "../../DataStore/DataProvider";
import { ILocation, locationWithinCircle } from "../../models/ILocation";
import { IPlaceData } from "../../models/Models";
import { DataStoreTable } from "./DataStoreTable";

export type IGroundWater = {
    id: string;
    altitude: number;
    center: ILocation;
    radius: number;
};

export class GroundWaterTable extends DataStoreTable<IGroundWater> {
    constructor(args: DataProviderArgs) {
        super(
            args,
            "ground-water",
            GroundWater,
            (obj: any) => obj as IGroundWater,
            (obj: any) => obj
        );
    }

    public distanceFromLocation(place: IPlaceData): number | undefined {
        for (const gw of this.allSync()) {
            if (
                place.altitude &&
                locationWithinCircle(place.location, { location: gw.center, radius: gw.radius })
            ) {
                return place.altitude - gw.altitude;
            }
        }

        return undefined;
    }
}
